let faq: string = require("./content/faq.html");
let mediaRequest: string = require("./content/media-request.html");
let terms: string = require("./content/terms.html");
let blockUI: string = require("./content/blockui-template.html");
let accountNotActivated: string = require("./content/account-not-activated.html");
let Templates = {
    accountNotActivated: accountNotActivated,
    faq: faq,
    mediaRequest: mediaRequest,
    terms: terms,
    blockUI: blockUI
};

export { Templates }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/assets/index.ts